import { Component, OnInit } from '@angular/core';
import { AuthService } from 'projects/frontend/src/app/shared/services/auth/auth.service';
import { ModalService } from 'projects/frontend/src/app/shared/services/modal.service';

@Component({
    selector: 'public-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    standalone: false
})
export class PublicFooterComponent implements OnInit {
  isLogged$ = this.authService.isLogged$;

  constructor(
    private authService: AuthService,
    public modalService: ModalService
  ) { }

  ngOnInit(): void {
  }

}
